import { Subject } from 'rxjs';

import { Injectable } from '@angular/core';

export type FormlyCustomEvents = 'TABLE_HEADER_COLUMN_CLICK';

export interface FormlyCustomEvent {
  event: FormlyCustomEvents;
  data: any;
}

@Injectable({
  providedIn: 'root',
})
export class ApmFormlyService {
  private customEventsSubject = new Subject<FormlyCustomEvent>();

  get customEvents$() {
    return this.customEventsSubject.asObservable();
  }

  dispatchEvent(event: FormlyCustomEvent) {
    this.customEventsSubject.next(event);
  }
}
